import React, { useState } from 'react';
import './RevoltTabs.css';

/**
 * RevoltTabs Component
 * Simple tabbed interface component
 */
export function RevoltTabs({ tabs, defaultTab, activeTab: controlledActiveTab, onTabChange, className = '' }) {
  const [internalActiveTab, setInternalActiveTab] = useState(defaultTab || tabs[0]?.id);

  // Use controlled activeTab if provided, otherwise use internal state
  const activeTab = controlledActiveTab !== undefined ? controlledActiveTab : internalActiveTab;
  const setActiveTab = onTabChange || setInternalActiveTab;

  const activeTabData = tabs.find(tab => tab.id === activeTab);

  return (
    <div className={`revolt-tabs ${className}`}>
      {/* Tab headers */}
      <div className="revolt-tabs-header">
        {tabs.map(tab => (
          <button
            key={tab.id}
            className={`revolt-tab-button ${activeTab === tab.id ? 'is-active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
            type="button"
          >
            {tab.icon && <i className={`fa-solid fa-${tab.icon}`}></i>}
            <span className="revolt-tab-label">{tab.label}</span>
            {tab.badge && (
              <span className="revolt-tab-badge">{tab.badge}</span>
            )}
          </button>
        ))}
      </div>

      {/* Tab content */}
      <div className="revolt-tabs-content">
        {activeTabData && activeTabData.content}
      </div>
    </div>
  );
}